import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ProjectVersionRoom} from "./projectVersionRoomDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";
import {ID} from "../../../core/metamodel/metaConstant";


@entityConfig()
export class ProjectVersionWindow extends DomainAncestor {

  @observable windowId : number;
  @observable projectVersion : LovItem
  @observable name : string;
  @observable displacement : string;
  @observable room : ProjectVersionRoom;
  @observable reachableOnlyByLadder : boolean;
  @observable securityType: LovItem;
  @observable height : number;
  @observable width : number;
  @observable glassArea : number;
  @observable frameLength : number;
  @observable angleAlpha : number;
  @observable angleBeta : number;
  @observable angleGama : number;
  @observable angleDelta : number;
  @observable angleEpsilon : number;
  @observable angleZeta : number;
  @observable angleEta : number;
  @observable angleShadowZ : number;
  @observable frameMaterial : LovItem;
  @observable frameMaterialWeight : number;
  @observable glassMaterial : LovItem;
  @observable glassMaterialWeight : number;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.windowId;
  }

  public setId(id: ID): void {
    this.windowId = <number>id;
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionWindowDomain.ts